import { render, staticRenderFns } from "./IncidentReportDownload.vue?vue&type=template&id=5c91da54&scoped=true"
import script from "./IncidentReportDownload.vue?vue&type=script&lang=ts"
export * from "./IncidentReportDownload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c91da54",
  null
  
)

export default component.exports